(function () {
 var RESULT_COPY = {
  forest_fairy: {
    title: 'Forest Fairy',
    desc: 'Earthy woodland tones, and magical details.'
  },
  midnight_garden: {
    title: 'Midnight Garden',
    desc: 'Dark, mysterious shades, and romantic evening energy.'
  },
  ocean_mist: {
    title: 'Ocean Mist',
    desc: 'Soft blues and effortless coastal elegance.'
  },
  coffee_date: {
    title: 'Coffee Date',
    desc: 'Warm neutrals, cozy and casual everyday charm.'
  }
};

  function initQuiz(root) {
    var screens = {
      intro: root.querySelector('[data-sq-screen="intro"]'),
      quiz: root.querySelector('[data-sq-screen="quiz"]'),
      results: root.querySelector('[data-sq-screen="results"]')
    };
    var questions = Array.prototype.slice.call(root.querySelectorAll('[data-sq-question]'));
    var progressFill = root.querySelector('[data-sq-progress-fill]');
    var currentLabel = root.querySelector('[data-sq-current]');
    var startBtn = root.querySelector('.sq-btn-start');
    var restartBtn = root.querySelector('.sq-btn-restart');
    var resultTitleEl = root.querySelector('[data-sq-result-title]');
    var resultDescEl = root.querySelector('[data-sq-result-desc]');
    var productsEl = root.querySelector('[data-sq-products]');
    var collectionLink = root.querySelector('[data-sq-collection-link]');

    var collections = {};
    try {
      collections = JSON.parse(root.getAttribute('data-collections')) || {};
    } catch (e) {
      collections = {};
    }

    var currentIndex = 0;
    var scores = {
  forest_fairy: 0,
  midnight_garden: 0,
  ocean_mist: 0,
  coffee_date: 0
};

    function showScreen(name) {
      Object.keys(screens).forEach(function (key) {
        if (!screens[key]) return;
        screens[key].hidden = key !== name;
      });
    }

    function resetQuiz() {
      currentIndex = 0;
      scores = {forest_fairy: 0, midnight_garden: 0, ocean_mist: 0, coffee_date: 0
};
      questions.forEach(function (q, i) {
        q.hidden = i !== 0;
      });
      updateProgress();
      showScreen('intro');
    }

    function updateProgress() {
      var pct = ((currentIndex) / questions.length) * 100;
      if (progressFill) progressFill.style.width = Math.max(pct, 4) + '%';
      if (currentLabel) currentLabel.textContent = Math.min(currentIndex + 1, questions.length);
    }

    function goToQuestion(index) {
      questions.forEach(function (q, i) {
        q.hidden = i !== index;
      });
      currentIndex = index;
      updateProgress();
    }

    function handleAnswer(scoreData) {
      Object.keys(scoreData).forEach(function (key) {
        if (scores.hasOwnProperty(key)) {
          scores[key] += scoreData[key];
        }
      });

      if (currentIndex < questions.length - 1) {
        goToQuestion(currentIndex + 1);
      } else {
        finishQuiz();
      }
    }

    function getWinner() {
      var winner = 'minimalist';
      var best = -Infinity;
      Object.keys(scores).forEach(function (key) {
        if (scores[key] > best) {
          best = scores[key];
          winner = key;
        }
      });
      return winner;
    }

    function formatMoney(amount) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
      } catch (e) {
        return '$' + Number(amount).toFixed(2);
      }
    }

    function renderProducts(products) {
      productsEl.innerHTML = '';

      if (!products || !products.length) {
        var empty = document.createElement('p');
        empty.className = 'sq-empty';
        empty.textContent = "No products linked yet for this result — add a collection handle in the section settings.";
        productsEl.appendChild(empty);
        return;
      }

      products.slice(0, 4).forEach(function (product) {
        var card = document.createElement('a');
        card.className = 'sq-product-card';
        card.href = '/products/' + product.handle;

        var img = document.createElement('img');
        var src = product.images && product.images[0];
        img.src = src ? (typeof src === 'string' ? src : src.src) : '';
        img.alt = product.title;
        img.loading = 'lazy';

        var title = document.createElement('p');
        title.className = 'sq-product-title';
        title.textContent = product.title;

        var price = document.createElement('p');
        price.className = 'sq-product-price';
        var variant = product.variants && product.variants[0];
        price.textContent = variant ? formatMoney(variant.price) : '';

        card.appendChild(img);
        card.appendChild(title);
        card.appendChild(price);
        productsEl.appendChild(card);
      });
    }

    function finishQuiz() {
      var winner = getWinner();
      var copy = RESULT_COPY[winner];
      resultTitleEl.textContent = copy.title;
      resultDescEl.textContent = copy.desc;
      showScreen('results');

      var handle = collections[winner];
      if (collectionLink && handle) {
        collectionLink.href = '/collections/' + handle;
      }
      if (!handle) {renderProducts([]);
        return;
      }

      productsEl.innerHTML = '<p class="sq-empty">Loading picks…</p>';

      fetch('/collections/' + handle + '/products.json?limit=4')
        .then(function (res) {
          if (!res.ok) throw new Error('Collection not found');
          return res.json();
        })
        .then(function (data) {
          renderProducts(data.products || []);
        })
        .catch(function () {
          renderProducts([]);
        });
    }

    if (startBtn) {
      startBtn.addEventListener('click', function () {
        showScreen('quiz');
        goToQuestion(0);
      });
    }

    if (restartBtn) {
      restartBtn.addEventListener('click', resetQuiz);
    }

    root.querySelectorAll('.sq-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scoreData = {};
        try {
          scoreData = JSON.parse(btn.getAttribute('data-scores')) || {};
        } catch (e) {}
        handleAnswer(scoreData);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.style-quiz').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
